import gql from 'graphql-tag';

/**
 * Fields of the project's electrician that the project page reads (documents, reports, guest entry
 * numbers per power company). Shared by the page query and the block project-rough-planning, so a
 * block save replaces every key of the stored electrician and no values of the previous electrician
 * remain.
 */
export const PROJECT_ELECTRICIAN_FIELDS = gql`
  fragment projectElectricianFields on Electrician {
    name
    id
    number
    street
    streetNumber
    zip
    city
    registeredIn
    certificateNumber
    contacts {
      firstname
      lastname
      position
      phone
      mobile
      email
    }
    powerCompanies {
      powerCompany {
        number
        _id
        company
      }
      guestEntryNumber
    }
  }
`;
